module.exports = __webpack_public_path__ + "img/use.8612f596.svg";